export const colorMap: Record<string, string> = {
  smotana: '#fffdd0',
  biela: '#ffffff',
  cierna: '#000000',
  siva: '#808080',
  svetlosiva: '#d3d3d3',
  tmavosiva: '#555555',
  modra: '#0000ff',
  svetlomodra: '#add8e6',
  tmavomodra: '#00008b',
  cervena: '#ff0000',
  ruzova: '#ff69b4',
  vinova: '#800000',
  cyklamen: '#e10074',
  puder: '#f2c6c2',
  oranzova: '#ffa500',
  zlta: '#ffff00',
  horcica: '#d2b55b',

  hneda: '#8b4513',
  bezova: '#f5f5dc',
  fango: '#7b6f5d',
  oliva: '#808000',
  zelena: '#008000',
  mentol: '#98ff98',
  fialova: '#800080',
  lila: '#c8a2c8',
  strieborna: '#c0c0c0',
  zlata: '#ffd700',
  antracit: '#2f2f2f',
  azur: '#007fff',
  pariz: '#003399',
};
